import { render, staticRenderFns } from "./SentimentRules.vue?vue&type=template&id=60a437ab&"
import script from "./SentimentRules.vue?vue&type=script&lang=js&"
export * from "./SentimentRules.vue?vue&type=script&lang=js&"
import style0 from "./SentimentRules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports